export const state = {
    pesquisaSatisfacao: {},
    pesquisasSatisfacao: [],
    modalExcluirPesquisaSatisfacao: false,
    modalCadastroPesquisaSatisfacao: false,
    modalVisualizarPesquisaSatisfacao: false,
    modalFinalizarPesquisaSatisfacao: false,
    formularioPesquisaSatisfacao: {}
}

export default {}